module.exports = __webpack_public_path__ + "static/media/pumpkinparrot.0efd5b1b.gif";